import { NavigationSlider } from '@yes.technology/react-toolkit'
import { useTranslation } from 'react-i18n-lite'
import { AreaLineCenter } from 'site/Renderer/components/DataTables/DataTable.styles'
import SectionDivider from 'site/Renderer/components/SectionDivider'

interface KanbanAreaLineProps {
  currentSection: number
  totalNavigationPages: number
  setCurrentSection: (section: number) => void
  title: string
  shouldDisplayNavigation?: boolean
  children?: React.ReactNode
}

const KanbanAreaLine = ({
  currentSection,
  totalNavigationPages,
  setCurrentSection,
  title,
  shouldDisplayNavigation = false,
  children
}: KanbanAreaLineProps) => {
  const { t } = useTranslation()

  const completeTitle = title || t('area-title.kanban')

  const centerHeaderElement = (
    <AreaLineCenter aria-label='Area line center'>
      {shouldDisplayNavigation && (
        <NavigationSlider
          currentPosition={currentSection + 1}
          first={1}
          total={totalNavigationPages}
          textForCurrent={t('kanban.section')}
          afterClick={(n) => setCurrentSection(n - 1)}
          doubleArrowhead={false}
          hierarchyLevel='level_2'
          heightClass='small'
        />
      )}
    </AreaLineCenter>
  )

  return (
    <>
      <SectionDivider
        title={completeTitle}
        isCollapsibleCard={false}
        centerHeaderElement={centerHeaderElement}
        rightHeaderElement={<div />}
        backgroundColor='#004099'
        hideCollapsibleCardArrow={false}
        isVisible={true}
      >
        {children}
      </SectionDivider>
    </>
  )
}

export default KanbanAreaLine
